module.exports = __webpack_public_path__ + "img/tertiary_10x3_z16.1ee9ced0.svg";